import type * as React from "react"

interface ScrollMenuArrowProps extends React.SVGProps<SVGSVGElement> {
  backgroundColor?: string
  arrowColor?: string
}

const ScrollMenuArrow = ({
  backgroundColor = "#EBEBEB",
  arrowColor = "#222",
  ...props
}: ScrollMenuArrowProps) => (
  <svg
    fill="none"
    height={48}
    viewBox="0 0 48 48"
    width={48}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24"
      fill={backgroundColor}
    />
    <path d="M19.809 31.97 29 22.779l1.414 1.415-9.192 9.192z" fill={arrowColor} />
    <path d="m21.222 15 9.192 9.192L29 25.607l-9.192-9.193z" fill={arrowColor} />
  </svg>
)
export default ScrollMenuArrow
